import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) =>{
 return(
  data.map(({ fieldName, placeholder, name, formType, validation, className, options, imageDimension, usedFileType }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    options:options,
    imageDimension: imageDimension,
    usedFileType: usedFileType
  }))
 )
}

export const fields: any = {
  eramanSignIn: mapFields(drilldownData["eramanSignIn"]),
  eramanRegistration: mapFields(drilldownData["eramanRegistration"]),
  eramanIcons: mapFields(drilldownData["eramanIcons"]),
  eramanForgotPassword: mapFields(drilldownData["eramanForgotPassword"]),
  eramanOTP: mapFields(drilldownData["eramanOTP"]),
  eramanUserProfile: mapFields(drilldownData["eramanUserProfile"]),
  epcMembership: mapFields(drilldownData["epcMembership"]),
  eramanProductReview: mapFields(drilldownData["eramanProductReview"]),
  eramanResetPassword: mapFields(drilldownData["eramanResetPassword"]),
  epcRenewal: mapFields(drilldownData["epcRenewal"]),
};
